import { useCallback, useMemo } from 'react';
import { type SupportedCountryCode } from '@zep-us/i18n';
import { useTranslation } from 'next-i18next';
import { type CategorySelectorState, MobileCategorySingleSelect, useInfoInitializeConfirmModal } from '@/views/build/features/category-select-view';
import { type CategoryNode, isNodeEmpty } from '@/views/build/features/category-tree';
import { getGradeNumber, isAllGrades } from '@/views/build/util';
export const SemesterMobileSelection = ({
  categoryInfo,
  userCountryCode
}: {
  categoryInfo: CategorySelectorState;
  userCountryCode: SupportedCountryCode;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    openInfoInitializeConfirmModal
  } = useInfoInitializeConfirmModal();
  const shouldShowGradeSelect = useMemo(() => {
    return !!categoryInfo.grade.gradeNodes && categoryInfo.grade.gradeNodes.length > 0;
  }, [categoryInfo.grade.gradeNodes]);
  const shouldShowSemesterSelect = useMemo(() => {
    if (userCountryCode !== 'KR') return false;
    if (!shouldShowGradeSelect || !categoryInfo.grade.selectedGradeNode) return false;
    const gradeNumber = getGradeNumber(categoryInfo.grade.selectedGradeNode.groupId);
    if (isAllGrades(gradeNumber)) return false;
    return true;
  }, [categoryInfo.grade.selectedGradeNode, shouldShowGradeSelect, userCountryCode]);
  const handleValueChangeWithConfirm = useCallback(async (value: CategoryNode) => {
    const hasChildSelections = !isNodeEmpty(categoryInfo.subject.selectedSubjectNode || categoryInfo.subject.selectedSubSubjectNode);
    if (hasChildSelections) {
      const confirmed = await openInfoInitializeConfirmModal();
      if (!confirmed) return;
    }
    categoryInfo.updateCategoryInfo(value);
  }, [categoryInfo, openInfoInitializeConfirmModal]);
  if (!shouldShowSemesterSelect) return null;
  return <MobileCategorySingleSelect value={categoryInfo.semester.selectedSemesterNode?.nodeId || null} categoryNodes={categoryInfo.semester.semesterNodes ?? []} onValueChange={handleValueChangeWithConfirm} title={t('common:school.info.semester')} placeholder={t('common:school.info.semester')} error={!!categoryInfo.errors.semesterId} helperText={categoryInfo.errors.semesterId} data-sentry-element="MobileCategorySingleSelect" data-sentry-component="SemesterMobileSelection" data-sentry-source-file="SemesterMobileSelection.tsx" />;
};